<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>ساکشن غبغب   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center m-5" >
                <template #default>روش لیپوماتیک برخلاف سایر روش ها مانند لیپوساکشن مشکلات ایمنی ایجاد نمی کند. چربی های موجود در نواحی مختلف بدن با روش فیزیکی تخریب شده و توسط دستگاه به صورت کاملا ایمن و بدون درد از بدن فرد خارج می شوند. چون در این روش از حرارت و لیزر استفاده نمی شود به همین دلیل امکان فیبروز در بافت زیر پوست کم می شود همین عامل سبب می شود که پوست بیمار سفت شده و به لیفت آن کمک شود. روش لیپوماتیک برای خانم ها و آقایان مورد استفاده قرار می گیرد. این عمل به صورت سرپایی انجام می شود و نیازی به بیهوشی ندارد. این عمل مقدار زیادی چربی را از بدن خارج می کند. کسانی که این عمل را انجام می دهند ادعا دارند کاهش سایز با این عمل برای طولانی مدت ادامه دارد و سلولیت را هم از بین می برد. ریکاوری پس از انجام عمل لیپوماتیک نیز ۳ تا ۷ روز است.   </template>
                </m-h4><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/asset\/before-qabqab.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/asset\/after-qabqab.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/asset\/11738836942.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/asset\/21738836942.jpg","direction":"vertical"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/asset\/21738837045.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/asset\/11738837045.jpg","direction":"vertical"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mSection200 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section200';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mSection200 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
